export const style = {
  th: {
    borderBottom: `1px solid #666`
  },
  td: {
    borderTop: `1px solid #666`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/partials/UserEditor/partials/AccountDetails/style/ColorBlind/table.js